<div class="pending-authz-container w-100">
    <div class="close-modal" (click)="closePendingPaymentModal()"><span>X</span></div>
    <div class="pending-authorization-container">
        <div class="title mt-3">
            <ng-container>
                {{pendingTitle |translate}}
            </ng-container>
        </div>
    </div>
    <div class="description mt-4">
        <p class="text-description">
            {{"Tienes" |translate}}
            <b>{{ "authz_pending_payments" |translate}} </b>
            {{ "en las siguientes cuentas. Revisalas y" | translate }}
            <b>{{ "autorizalas en el Centro de notificaciones."|translate}}</b>
        </p>
        <p class="text-description mt-3">
            {{ "Selecciona una cuenta"|translate}}:
        </p>
        <div>
            <div class="elements-container" *ngIf="contractsPendingPayments.length > 0">
                <div class="elements" *ngFor="let contract of contractsPendingPayments">
                    <div class="element d-flex align-items-start gap-1 p-1">
                        <div class="list-element" (click)="goToNotificationCenter(contract.contractId)">{{'Cuenta'|translate}} <span>{{contract.idReferenceContract}}
                            ({{contract.type}})</span> - {{contract.ownerName}}</div>
                    </div>
                    <p-divider layout="horizontal" type="solid" *ngIf="contractsPendingPayments.length > 1"></p-divider>
                </div>
            </div>
        </div>
    </div>
</div>